import VehicleUnavailabilityFormLayout, { transformValues } from './form'
import GenericCreateForm from '../common/create'

export default () => (
  <GenericCreateForm formLayoutComponent={<VehicleUnavailabilityFormLayout />} transformValues={transformValues} />
)
